import { useI18n } from "../lib/i18n";

const WORKSPACE_TABS = ["listings", "work", "orders"] as const;
export type DashboardWorkspaceTab = typeof WORKSPACE_TABS[number];

type MobileDashboardTabsProps = {
  activeTab: DashboardWorkspaceTab;
  pendingPurchases: number;
  onSelect: (tab: DashboardWorkspaceTab) => void;
};

/** Original phone workspace navigation, separate from the desktop profile tabs. */
export function MobileDashboardTabs({ activeTab, pendingPurchases, onSelect }: MobileDashboardTabsProps) {
  const { t } = useI18n();
  const labels = { listings: t("dashboard.workspace.listings", "Listings"), work: t("dashboard.workspace.work", "Work"), orders: t("dashboard.workspace.orders", "Orders") };
  return (
    <nav className="dashboard-workspace-tabs sm:hidden" role="tablist" aria-label={t("dashboard.workspace.sections", "Dashboard sections")}>
      {WORKSPACE_TABS.map((tab, index) => (
        <button key={tab} type="button" role="tab" id={`dashboard-tab-${tab}`} aria-controls="dashboard-workspace"
          aria-selected={activeTab === tab} tabIndex={activeTab === tab ? 0 : -1}
          onClick={() => onSelect(tab)}
          onKeyDown={(event) => {
            if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
            event.preventDefault();
            const nextIndex = event.key === "Home" ? 0 : event.key === "End" ? 2 : (index + (event.key === "ArrowRight" ? 1 : 2)) % WORKSPACE_TABS.length;
            const nextTab = WORKSPACE_TABS[nextIndex];
            onSelect(nextTab);
            document.getElementById(`dashboard-tab-${nextTab}`)?.focus({ preventScroll: true });
          }}>
          {labels[tab]}
          {tab === "orders" && pendingPurchases > 0 && <span className="dashboard-order-count">{pendingPurchases}</span>}
        </button>
      ))}
    </nav>
  );
}
